// import Cedem from './Index.vue'
import Permissions from "../../models/Permissions";

const AuditoriaContribuicoes = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/Auditoria",
    name: "AuditoriaContribuicoes",
    component: AuditoriaContribuicoes,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "SPED Contribuições",
      icon: "fa fa-files-o",
      group: "Auditoria",
      permissions,
    },
  },
];
